import * as React from "react";
import {cx} from "emotion";

import "./sorting-direction.scss";

import {stateChangeNestedValue} from "@Common/react/state-change-nested-value";

export const SortingDirection = ({sorting,iconColor}) => sorting.value && (
    <div
        className="sorting-direction sorting-direction-2lu"
        onClick={() => stateChangeNestedValue(sorting, ["direction"], (d) => d === "asc" ? "desc" : "asc")}
    >
        <i 
            className={cx("fa", sorting.value.direction === "asc" ? "fa-sort-alpha-asc" : "fa-sort-alpha-desc")}
            style={{color: iconColor,}}
            xd-qa-type="icon"
            xd-qa-name="sort"
        />
    </div>
);
